const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_SELECTED_ID(state, selectedId) {
    state.selectedId = selectedId
  },
  UPDATE_ID(state, id) {
    state.id = id
  },
  UPDATE_ADDRESS1(state, address1) {
    state.address1 = address1
  },
  UPDATE_ADDRESS2(state, address2) {
    state.address2 = address2
  },
  UPDATE_ADDRESS3(state, address3) {
    state.address3 = address3
  },
  UPDATE_POSTCODE(state, postcode) {
    state.postcode = postcode
  },
  UPDATE_CITY(state, cityId) {
    state.cityId = cityId
  },
  UPDATE_CITY_NAME(state, cityName) {
    state.cityName = cityName
  },
  UPDATE_STATE(state, stateId) {
    state.stateId = stateId
  },
  UPDATE_STATE_NAME(state, stateName) {
    state.stateName = stateName
  },
  UPDATE_COUNTRY(state, countryId) {
    state.countryId = countryId
  },
  UPDATE_COUNTRY_NAME(state, countryName) {
    state.countryName = countryName
  },
  UPDATE_OTHER_STATE_NAME(state, otherStateName) {
    state.otherStateName = otherStateName
  }
}

const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateSelectedId({
    commit
  }, selectedId) {
    commit('UPDATE_SELECTED_ID', selectedId);
  },
  updateId({
    commit
  }, id) {
    commit('UPDATE_ID', id);
  },
  updateAddress1({
    commit
  }, address1) {
    commit('UPDATE_ADDRESS1', address1);
  },
  updateAddress2({
    commit
  }, address2) {
    commit('UPDATE_ADDRESS2', address2);
  },
  updateAddress3({
    commit
  }, address3) {
    commit('UPDATE_ADDRESS3', address3);
  },
  updatePostcode({
    commit
  }, postcode) {
    commit('UPDATE_POSTCODE', postcode);
  },
  updateCity({
    commit
  }, cityId) {
    commit('UPDATE_CITY', cityId);
  },
  updateCityName({
    commit
  }, cityName) {
    commit('UPDATE_CITY_NAME', cityName);
  },
  updateState({
    commit
  }, stateId) {
    commit('UPDATE_STATE', stateId);
  },
  updateStateName({
    commit
  }, stateName) {
    commit('UPDATE_STATE_NAME', stateName);
  },
  updateCountry({
    commit
  }, countryId) {
    commit('UPDATE_COUNTRY', countryId);
  },
  updateCountryName({
    commit
  }, countryName) {
    commit('UPDATE_COUNTRY_NAME', countryName);
  },
  updateOtherStateName({
    commit
  }, otherStateName) {
    commit('UPDATE_OTHER_STATE_NAME', otherStateName);
  }
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  SelectedId: state => {
    return state.selectedId
  },
  Id: state => {
    return state.id
  },
  Address1: state => {
    return state.address1
  },
  Address2: state => {
    return state.address2
  },
  Address3: state => {
    return state.address3
  },
  Postcode: state => {
    return state.postcode
  },
  CityId: state => {
    return state.cityId
  },
  CityName: state => {
    return state.cityName
  },
  StateId: state => {
    return state.stateId
  },
  StateName: state => {
    return state.stateName
  },
  CountryId: state => {
    return state.countryId
  },
  CountryName: state => {
    return state.countryName
  },
  OtherStateName: state => {
    return state.otherStateName
  }
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      selectedId: 0,
      id: 0,
      address1: "",
      address2: "",
      address3: "",
      postcode: "",
      cityId: 0,
      cityName: "",
      stateId: 0,
      stateName: "",
      countryId: 0,
      countryName: "",
      otherStateName: ""
    }
  },
  getters,
  actions,
  mutations
}
